import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from 'src/store/actions';

/* Events */
export const FETCH_EVENTS = 'FETCH_EVENTS';
export const REQUEST_EVENTS = 'REQUEST_EVENTS';
export const SUCCESS_EVENTS = 'SUCCESS_EVENTS';
export const FAILURE_EVENTS = 'FAILURE_EVENTS';

export const fetchEvents = (pageable?: PageableQueryParams) => action(FETCH_EVENTS, { pageable });
export const requestEvents = () => action(REQUEST_EVENTS);
export const requestEventsSuccess = (response: any) => action(SUCCESS_EVENTS, { response });
export const requestEventsFailure = (error: any) => action(FAILURE_EVENTS, { error });

/* Event Languages */
export const FETCH_EVENT_LANGUAGES = 'FETCH_EVENT_LANGUAGES';
export const REQUEST_EVENT_LANGUAGES = 'REQUEST_EVENT_LANGUAGES';
export const SUCCESS_EVENT_LANGUAGES = 'SUCCESS_EVENT_LANGUAGES';
export const FAILURE_EVENT_LANGUAGES = 'FAILURE_EVENT_LANGUAGES';

export const fetchEventLanguages = () => action(FETCH_EVENT_LANGUAGES);
export const requestEventLanguages = () => action(REQUEST_EVENT_LANGUAGES);
export const requestEventLanguagesSuccess = (response: any) => action(SUCCESS_EVENT_LANGUAGES, { response });
export const requestEventLanguagesFailure = (error: any) => action(FAILURE_EVENT_LANGUAGES, { error });
